{
	"submitTitle": "Selectează materialul",
	"summary": {
		"title": "Rezumat",
		"declarationTypeTitle": "Tip declarație",
		"projectReferenceTitle": "Referință proiect"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Selectați tipul declarației",
			"customerProject": {
				"title": "Proiect client",
				"description": "Materialul a fost utilizat pentru un proiect extern. Acum trebuie să furnizez o declarație care detaliază reducerile de CO\u2082 pentru clientul meu."
			},
			"internalProjectOrProduct": {
				"title": "Proiect intern / produs",
				"description": "Materialul a fost utilizat pentru un proiect intern sau un produs. Trebuie să creez o declarație pentru a revendica reducerile de CO\u2082 pentru operațiunile noastre."
			}
		},
		"addProjectReferenceSection": {
			"title": "Adăugați referința proiectului",
			"subTitle": "Trebuie să alocați reducerile de CO\u2082 unei referințe de proiect pentru care doriți să creați declarația.",
			"projectReferencePlaceholder": "Referință proiect"
		},
		"selectProjectSection": {
			"title": "Selectați un proiect",
			"createNewProjectPlaceholder": "Creează un proiect nou"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Tipul declarației este obligatoriu",
		"projectReferenceRequired": "Referința proiectului este obligatorie",
		"fetchProjectsError": "Preluarea proiectelor anterioare a eșuat"
	}
}
